module.exports = __webpack_public_path__ + "static/media/4.fa0608f1.jpeg";